module.exports = __webpack_public_path__ + "static/img/gift-15.c1d35a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/winter-camp/assets/gift-15.png
// module id = 359
// module chunks = 140